/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_Past_YearInputs */

const en_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Past Year`)
};

const fr_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Année passée`)
};

const de_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letztes Jahr`)
};

const it_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anno scorso`)
};

const ru_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошлый год`)
};

const es_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El año pasado`)
};

const zh_cn2_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过去一年`)
};

const ja_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去1年間`)
};

const hi_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछले एक साल`)
};

const pt_pt2_date_range_past_year = /** @type {(inputs: Date_Range_Past_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano passado`)
};

/**
* | output |
* | --- |
* | "Past Year" |
*
* @param {Date_Range_Past_YearInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_past_year = /** @type {((inputs?: Date_Range_Past_YearInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_Past_YearInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_date_range_past_year(inputs)
	if (locale === "de") return de_date_range_past_year(inputs)
	if (locale === "it") return it_date_range_past_year(inputs)
	if (locale === "ru") return ru_date_range_past_year(inputs)
	if (locale === "es") return es_date_range_past_year(inputs)
	if (locale === "zh-CN") return zh_cn2_date_range_past_year(inputs)
	if (locale === "ja") return ja_date_range_past_year(inputs)
	if (locale === "hi") return hi_date_range_past_year(inputs)
	if (locale === "pt-PT") return pt_pt2_date_range_past_year(inputs)
	return en_date_range_past_year(inputs)
});